import _ from 'lodash';
import { createActions } from 'reduxsauce';

import API from '../../api';

import { defaultRegion, defaultPackageName } from '../../helpers/constants';


const { Types, Creators } = createActions({
  getPriceListSuccess: ['priceList'],
  getPriceListFailure: ['errorMessage'],
  getPriceListRequest: () => async (dispatch, state) => {
    try {
      const currentState = state();
      const primaryRegion = currentState.profile?.role === 'manager' && !_.isEmpty(currentState.clientList?.manageeInfo)
        ? currentState.clientList?.manageeInfo?.primaryRegion || defaultRegion
        : currentState.profile?.primaryRegion || defaultRegion;
      const packageName = currentState.profile?.role === 'manager' && !_.isEmpty(currentState.clientList?.manageeInfo)
        ? currentState.clientList?.manageeInfo?.packageName || defaultPackageName
        : '';
      const response = await API.priceList.get(primaryRegion, packageName);
      const { ok, problem, data } = response || {};
      const error = data?.error || {};
      const priceList = response?.data?.priceList || [];
      const errorMessage = !ok
        ? (error?.message || data?.message || problem)
        : '';

      if (errorMessage) {
        dispatch(Creators.getPriceListFailure(errorMessage));
        return;
      }

      dispatch(Creators.getPriceListSuccess(priceList));
    } catch (error) {
      dispatch(Creators.getPriceListFailure(error.message || error.reason));
    }
  },
});

export const PriceListTypes = Types;
export default Creators;
